import React, { useState } from "react";
import "../assets/styles/navbar.css";
import { FaHome, FaUser, FaRegFileAlt, } from "react-icons/fa";
import { FaRegImage } from "react-icons/fa6";
import { FaCodeBranch, FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";




const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">Sk.</div>
      

      {/* Menu Items */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
      <li><Link to="/"><FaHome /> Home</Link></li>
      <li><Link to="/about"><FaUser /> About</Link></li>
      <li><Link to="/project"><FaRegImage /> Projects</Link></li>
      <li><Link to="/resume"><FaRegFileAlt /> Resume</Link></li>
      {/* <li><Link to="/blogs"><FaBlog /> Blogs</Link></li> */}
    </ul>
      

      {/* Right Button */}
      <div className="right-btn">
        <button>
          <FaCodeBranch /> <FaStar />
        </button>
      </div>

      {/* Hamburger Icon */}
      <div
        className={`hamburger ${isOpen ? "toggle" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  );
};

export default Navbar;
